import { Form, Input, Button, message } from "antd";
import React from "react";
import {
    UserOutlined,
    EyeTwoTone,
    EyeInvisibleOutlined,
    LockOutlined,
} from "@ant-design/icons";
import HttpHelper from "../../helper/http-helper";
import Config from "../../config/config";

export default class Login extends React.PureComponent<{}, any> {
    constructor(props: any) {
        super(props);

        this.state = { username: '', password: '' };
    }

    public onLogin() {
        const { username, password } = this.state;

        if (username === '' || password === '') {
            return;
        }

        HttpHelper.post('/passport/login', { username, password }).then((res) => {
            Config.username = res.data.username;
            Config.token = res.data.token;
            localStorage['token'] = JSON.stringify(res.data);
            HttpHelper.addToken(Config.token);

            // @ts-ignore
            this.props.history.push('/manage/welcome');
        }).catch((err: any) => {
            console.info(err);
            message.error(err.message || '登录错误');
        });
    }

    render() {
        return (
            <div>
                <h1>Sign in</h1>
                <div>
                    <Form>
                        <Form.Item>
                            <Input
                                size="large"
                                placeholder="请输入用户名"
                                maxLength={20}
                                onChange={(e) => this.setState({ username: e.target.value })}
                                prefix={<UserOutlined />}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Input.Password
                                size="large"
                                placeholder="请输入密码"
                                maxLength={50}
                                onChange={(e) => this.setState({ password: e.target.value })}
                                prefix={<LockOutlined />}
                                iconRender={(visible) =>
                                    visible ? (
                                        <EyeTwoTone />
                                    ) : (
                                        <EyeInvisibleOutlined />
                                    )
                                }
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" block onClick={() => this.onLogin()}>
                                登 录
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        );
    }
}
